import { render, staticRenderFns } from "./AccountRoute.vue?vue&type=template&id=1b23a4f8&scoped=true"
import script from "./AccountRoute.vue?vue&type=script&lang=ts"
export * from "./AccountRoute.vue?vue&type=script&lang=ts"
import style0 from "./AccountRoute.vue?vue&type=style&index=0&id=1b23a4f8&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b23a4f8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b23a4f8')) {
      api.createRecord('1b23a4f8', component.options)
    } else {
      api.reload('1b23a4f8', component.options)
    }
    module.hot.accept("./AccountRoute.vue?vue&type=template&id=1b23a4f8&scoped=true", function () {
      api.rerender('1b23a4f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/account/AccountRoute.vue"
export default component.exports